import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-personalizacion',
  templateUrl: './personalizacion.component.html',
  styleUrls: ['./personalizacion.component.css']
})
export class PersonalizacionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
